import React from 'react';

import AddModelBooksToPackageButton from '@components/ActivePackages/AddModelBooksToPackageButton';

/** Aggiunge a un package i book della modella che ho messo tra i favourites. */
const AddFavouriteBooksButton = ({ modelID, noTooltip }) => (
    <AddModelBooksToPackageButton modelID={modelID} noTooltip={noTooltip} variant="favourites" />
);

export default AddFavouriteBooksButton;
